import { PropsWithChildren } from 'react';
import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { BuilderComposite } from '../types';
import { answerMap } from './answersMap';
import { createAnswerResolver } from './createAnswerResolver';

type CorrectionTitleProps = { title: string };
type CorrectionContextProps = { context: string };

function CorrectionTitle({ title }: CorrectionTitleProps) {
  return (
    <Text
      text={title}
      size="text-base"
      className="w-full font-poppins font-400 text-base-content"
    />
  );
}

function CorrectionContext({ context }: CorrectionContextProps) {
  return (
    <ConditionalRenderer condition={!!context}>
      <HtmlPreview html={context} format="default" className="w-full" />
    </ConditionalRenderer>
  );
}

function CorrectionBase({ children }: PropsWithChildren) {
  return (
    <div className="flex w-full flex-col items-start gap-6">{children}</div>
  );
}

export const correctionBuilder: BuilderComposite = {
  Title: CorrectionTitle,
  Context: CorrectionContext,
  Base: CorrectionBase,
  Answer: createAnswerResolver(answerMap, 'correction'),
};
